/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden[_ngcontent-%COMP%] {\n  display: none; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.scss.shim.ngstyle.js.pre-build-optimizer.js